import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import EditorPublishButton from 'ContentEditorUI/components/shared/EditorPublishButton';
import { getCannotPublishOnActiveDomainReason, getIsPublishEnabled, getIsUnpublishEnabled, getPagesTypeHasSavedViews, getHasPermissionsToPublish
// @ts-expect-error Untyped module
} from '../redux/selectors/pagePublishSelectors';
import { getPageErrorLabels, getPageWarningLabels
// @ts-expect-error Untyped module
} from '../redux/selectors/pageWarningsAndSuggestionsSelectors';
import { getCanSchedule, getIsUngatedForCMPPublishing } from '../redux/selectors/authSelectors';
import MABPublishConfirmModal from '../components/MABPublishConfirmModal';
import PagePublishConfirmModalBody from '../components/PagePublishConfirmModalBody';
import UseCaseTourCompleteModal from '../components/UseCaseTourCompleteModal';

// @ts-expect-error Untyped module
import { updateFocusedItem } from 'page-editor-ui/redux/actions/pageFocusActions';
import usePublishLifecycleHandlers from '../hooks/usePublishLifecycleHandlers';
import { getAbMasterName, getIsABVariant } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import { getIsMABExperiment, getIsMabVariant, getMABExperimentIsStarted, getMABExperimentPrimayVariantName
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { getIsBlogListingPage, getIsLandingOrSitePage, getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getHasContentTypeLimitReducerAndExceededLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
// @ts-expect-error Untyped module
import { getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getUnifiedPublishType } from 'ContentEditorUI/redux/selectors/publishSelectors';
import { getContentModelPublicAccessRules, getContentModelPassword } from '../redux/selectors/pageContentModelSelectors';
// @ts-expect-error Untyped module
import { getDashboardUrl } from '../redux/selectors/urlSelectors';
// @ts-expect-error Untyped module
import { getHasExceededMlangPagesLimit } from '../redux/selectors/pageLimitSelectors';
// @ts-expect-error Untyped module
import { getPageUsageLimitExceededLockedPulishButtonUpgradeModalKey } from '../redux/selectors/downgradeSelectors';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import usePublishActionHandlers, { useCMPPublishActionHandlers } from 'ContentEditorUI/components/publishing/hooks/usePublishActionHandlers';
import { getPageSettingsFullUrl } from '../redux/selectors/pageSettingsSelectors';
import { CONTENT_PLATFORM_PROPERTY_NAME, ContentObjectTypes, getContentPropertyValue } from 'content-management-data-lib';
import { getContentModelId, getContentModelPageExpiryRedirectUrl } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getMembershipSsoEnabledForDomain } from '../redux/selectors/membershipsSelectors';
import { EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD } from 'ui-memberships-settings-lib/components/alerts/RegistrationEmailSendingAcknowledgement';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { getMembershipsEmailSendAcknowledgementDisabledTooltipI18nKey } from 'ui-memberships-settings-lib/utils/tooltips';
// @ts-expect-error Untyped module
import { search } from 'ContentEditorUI/api/PagesApi';
import useContentCrmObject from 'ContentEditorUI/components/publishing/hooks/useContentCrmObject';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PagePublishButtonContainer = () => {
  var _pagePublicAccessRule;
  const cannotPublishOnDomainReason = useSelector(getCannotPublishOnActiveDomainReason);
  const errors = useSelector(getPageErrorLabels);
  const warnings = useSelector(getPageWarningLabels);
  const canSchedule = useSelector(getCanSchedule);
  const publishEnabled = useSelector(getIsPublishEnabled);
  const unpublishEnabled = useSelector(getIsUnpublishEnabled);
  const isAbVariant = useSelector(getIsABVariant);
  const isMabVariant = useSelector(getIsMabVariant);
  const abPrimaryName = useSelector(getAbMasterName);
  const mabPrimaryName = useSelector(getMABExperimentPrimayVariantName);
  const isMABExperiment = useSelector(getIsMABExperiment);
  const mabExperimentIsStarted = useSelector(getMABExperimentIsStarted);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const controlCenterUrl = useSelector(getDashboardUrl);
  const hasExceededMlangSitePagesLimit = useSelector(getHasExceededMlangPagesLimit);
  const tooltipOverride = useMemo(() => {
    if (hasExceededMlangSitePagesLimit) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "mLang.sitePageLimitExceededError",
        options: {
          controlCenterUrl
        }
      });
    } else if (isReadOnlyMode) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'app.readOnly.publishButton.pages'
      });
    }
    return;
  }, [controlCenterUrl, hasExceededMlangSitePagesLimit, isReadOnlyMode]);
  const [mabConfirmModalOpen, setMabConfirmModalOpen] = useState(false);
  const [showUseCaseTourCompleteModal, setShowUseCaseTourCompleteModal] = useState(false);
  const pageSettingsFullUrl = useSelector(getPageSettingsFullUrl);
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const hasExceededContentTypeLimit = useSelector(getHasContentTypeLimitReducerAndExceededLimit);
  const hasStagingDomain = useSelector(getHasStagingDomain);
  const upgradeModalKey = useSelector(getPageUsageLimitExceededLockedPulishButtonUpgradeModalKey);
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeModalKey);
  const isLandingPages = useSelector(getIsLandingPage);
  const contentId = useSelector(getContentModelId);
  const contentTypeHasSavedViews = useSelector(getPagesTypeHasSavedViews);
  const publishLifecycleHandlers = usePublishLifecycleHandlers(setShowUseCaseTourCompleteModal);
  const {
    publish,
    unpublish
  } = usePublishActionHandlers(publishLifecycleHandlers);
  const {
    publish: publishViaCMP,
    unpublish: unpublishViaCMP,
    schedulePublishUnpublish: schedulePublishUnpublishViaCMP
  } = useCMPPublishActionHandlers(Object.assign({}, publishLifecycleHandlers, {
    contentObjectType: isLandingPages ? ContentObjectTypes.LANDING_PAGE : ContentObjectTypes.SITE_PAGE,
    objectId: contentId,
    shouldConvertCMPObjectToInstanceObject: false
  }));
  const isLandingOrSitePage = useSelector(getIsLandingOrSitePage);
  const isUngatedForPublishWithContentCrmObject = useSelector(getIsUngatedForCMPPublishing);
  const shouldUseCMPPublicationAPI = isLandingOrSitePage && isUngatedForPublishWithContentCrmObject;
  const unifiedPublishType = useSelector(getUnifiedPublishType);
  const hasPermissionsToPublish = useSelector(getHasPermissionsToPublish);
  const buttonTextKey = useMemo(() => {
    let key = unifiedPublishType;
    if (!hasPermissionsToPublish && !hasExceededContentTypeLimit) {
      key = 'notAuthorized';
    }
    if (hasStagingDomain) {
      key = `staging.${key}`;
    }
    return `header.publishButton.${key}.label`;
  }, [hasExceededContentTypeLimit, hasPermissionsToPublish, hasStagingDomain, unifiedPublishType]);
  const [unregisteredContactsCount, setUnregisteredContactsCount] = useState(0);
  const [isEmailSendingAcknowledgementChecked, setIsEmailSendingAcknowledgementChecked] = useState(false);
  const pagePublicAccessRules = useSelector(getContentModelPublicAccessRules);
  const pagePassword = useSelector(getContentModelPassword);
  const ssoEnabledForPageDomain = useSelector(getMembershipSsoEnabledForDomain);
  const pageIsPublic = (pagePublicAccessRules.length === 0 || pagePublicAccessRules[0].type === PublicAccessRuleTypes.PUBLIC) && !pagePassword;
  const pageHasAccessGroupsMembership = ((_pagePublicAccessRule = pagePublicAccessRules[0]) === null || _pagePublicAccessRule === void 0 ? void 0 : _pagePublicAccessRule.type) === PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP && !ssoEnabledForPageDomain;
  const disabledForMissingEmailSendingAcknowledgement = pageHasAccessGroupsMembership && unregisteredContactsCount >= EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD && !isEmailSendingAcknowledgementChecked;
  const handleUnregisteredContactsCountFetchSuccess = count => {
    setUnregisteredContactsCount(count);
  };
  const handleEmailSendingAcknowledgementChange = checked => {
    setIsEmailSendingAcknowledgementChecked(checked);
  };
  const pageExpiryRedirectUrl = useSelector(getContentModelPageExpiryRedirectUrl);
  const {
    contentCrmObject
  } = useContentCrmObject();
  const unpublishExpiryUrl = contentCrmObject ? getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.UNPUBLISH_EXPIRY_URL) : pageExpiryRedirectUrl;
  const loadRedirectUrlOptions = (input, callback) => {
    search(input).then(resp => {
      callback(null, {
        options: resp.objects.map(page => {
          return {
            text: page.name ? `${page.name} (${page.url})` : page.url,
            value: page.url
          };
        }).filter(page => {
          return page.value !== unpublishExpiryUrl;
        })
      });
    }).catch(() => {
      // no op
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EditorPublishButton, {
      cannotPublishOnDomainReason: cannotPublishOnDomainReason,
      errors: errors,
      warnings: warnings,
      canSchedule: canSchedule && !isBlogListingPage && !hasExceededContentTypeLimit && !hasStagingDomain,
      publishEnabled: publishEnabled,
      unpublishEnabled: unpublishEnabled,
      testVariationTooltipPropsForApproval: {
        isTestVariation: isAbVariant || isMabVariant,
        testVariationDisabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "approvals.testVariationRequestApprovalDisabledTooltip",
          options: {
            name: abPrimaryName || mabPrimaryName
          }
        })
      },
      shouldOverrideDefaultButtonTextKey: hasStagingDomain,
      buttonTextKey: buttonTextKey,
      updateFocusedItemAction: updateFocusedItem,
      tooltipOverride: tooltipOverride,
      lockedPublishButtonProps: {
        isLocked: hasExceededContentTypeLimit,
        onClickLocked: openUpgradeModal
      },
      schedulingOptionsModalProps: {
        dashboardUrl: controlCenterUrl,
        allowBackdating: false,
        canScheduleUnpublish: true,
        contentTypeHasSavedViews,
        unpublishRedirectOptions: {
          allowRedirectOnUnpublish: true,
          loadRedirectUrlOptions: shouldUseCMPPublicationAPI ? loadRedirectUrlOptions : undefined
        }
      },
      confirmPublishActionProps: {
        publishConfirmDisabled: disabledForMissingEmailSendingAcknowledgement,
        publishConfirmDisabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getMembershipsEmailSendAcknowledgementDisabledTooltipI18nKey()
        }),
        publishConfirmModalBodyContent: /*#__PURE__*/_jsx(PagePublishConfirmModalBody, {
          isEmailSendingAcknowledgementChecked: isEmailSendingAcknowledgementChecked,
          onEmailSendingAcknowledgementChange: handleEmailSendingAcknowledgementChange,
          onUnregisteredContactsCountFetchSuccess: handleUnregisteredContactsCountFetchSuccess
        }),
        shouldConfirmPublishAction: !pageIsPublic
      },
      customPublishActionProps: {
        shouldUseCustomPublishHandler: isMABExperiment && !mabExperimentIsStarted,
        customPublishHandler: () => setMabConfirmModalOpen(true)
      },
      publish: shouldUseCMPPublicationAPI ? publishViaCMP : publish,
      unpublish: shouldUseCMPPublicationAPI ? unpublishViaCMP : unpublish,
      schedulePublishUnpublish: shouldUseCMPPublicationAPI ? schedulePublishUnpublishViaCMP : undefined,
      isNotAuthorizedToPublish: !hasPermissionsToPublish && !hasExceededContentTypeLimit,
      isUsingCMPPublish: shouldUseCMPPublicationAPI
    }), mabConfirmModalOpen && /*#__PURE__*/_jsx(MABPublishConfirmModal, {
      dismissCallback: () => setMabConfirmModalOpen(false)
    }), showUseCaseTourCompleteModal && /*#__PURE__*/_jsx(UseCaseTourCompleteModal, {
      onClose: () => {
        setShowUseCaseTourCompleteModal(false);
      },
      websiteLink: pageSettingsFullUrl
    })]
  });
};
export default PagePublishButtonContainer;